<template>
  <div class="columns is-multiline is-marginless is-main-content is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="column is-12 is-marginless">
        <input-periode
          v-model="critereRecherche.datesDebut"
          :label="$t('listeCampagnes.filtre.dateDebut')">
        </input-periode>
      </div>
      <div class="column is-12 is-marginless">
        <input-periode
          v-model="critereRecherche.datesFin"
          :label="$t('listeCampagnes.filtre.dateFin')">
        </input-periode>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCampagnes.filtre.libelle')">
          <b-input v-model="critereRecherche.libelle"></b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeCampagnes.filtre.libelleInterne')">
          <b-input v-model="critereRecherche.libelleInterne"></b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input :label="$t('listeCampagnes.filtre.marque')"
          v-model="critereRecherche.marqueIds"
          :query="(search) => pGetAll(PARAMETRES_KEYS.marque, {
            query:
            {
              auto: search,
              actif: true,
            },
          })">
          <template slot-scope="props">
            <div>{{ props.option.libelle }}</div>
          </template>
        </query-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <query-tag-input :label="$t('listeCampagnes.filtre.tag')"
          v-model="critereRecherche.tagIds"
          :query="(search) => getAllTags({
            query:
            {
              auto: search,
              actif: true,
              moduleTag: CAMPAGNE,
            },
          })">
          <template slot-scope="props">
            {{ props.option.libelle }}
          </template>
        </query-tag-input>
      </div>
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeCampagnes.filtre.actif')">
            <b-select v-model="critereRecherche.actif">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeCampagnes.filtre.newsLetter')">
            <b-select v-model="critereRecherche.newsLetter">
              <option :value="null"></option>
              <option :value="true"> {{ $t('general.oui') }}
              </option>
              <option :value="false"> {{ $t('general.non') }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.appliquer')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererCritereRecherche from '@/services/bodac/campagne/genererCritereRecherche';
import { SET_CRITERE } from '@/store/modules/bodac/campagne/campagne-mutation-type';
import queryTagInput from '@/components/general/tagInput/queryTagInput';
import { pGetAll } from '@/api/parametre/index';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { CAMPAGNE } from '@/configuration/parametrage/tagConf';
import { getAll as getAllTags } from '@/api/tag/index';
import inputPeriode from '@/components/general/inputPeriode';

const Societe = createNamespacedHelpers('societe');
const Campagne = createNamespacedHelpers('campagne');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'FiltreListeCampagne',
  computed: {
    ...Campagne.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  data() {
    return {
      critereRecherche: null,
      pGetAll,
      PARAMETRES_KEYS,
      CAMPAGNE,
      getAllTags,
    };
  },
  components: {
    queryTagInput,
    inputPeriode,
  },
  methods: {
    ...Campagne.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    viderCritere() {
      this.critereRecherche = genererCritereRecherche();
    },
    appliquerCritere() {
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    initializeFiltre() {
      this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
